import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(e, fallback = "Ocorreu um erro. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" · ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}
